/**
 * Whether AI Coach is switched on (an AI key is configured — see
 * GET /api/ai-coach/status). While false the AI Coach page shows "Coming soon"
 * and menus tag the item "Soon". Unknown while loading; errors count as off.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useAiCoachAvailable(): boolean | undefined {
  const q = useQuery({
    queryKey: ['ai-coach-status'],
    queryFn: () => api.get<{ available: boolean }>('/api/ai-coach/status'),
    staleTime: 5 * 60_000,
  });
  if (q.isError) return false;
  return q.data?.available;
}
